import styled from "styled-components";

export const Legend = styled.legend`
    font: normal normal normal 14px/20px Circular Std Book;
    color: #454546;
    margin-bottom: 20px;
`;

export const ContainerButton = styled.div`
    padding: 0px;
    padding-right: 15px;
    margin-top: 49px;

    @media (max-width: 600px) {
        margin-top: 10px;
        padding-right: 0px;
        margin-bottom: 40px;
    }
`